module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-8-8450a534c9e0de1fb3f29466ea1e9bc1.jpg";